export default "__VITE_ASSET__tcfoNr5f__"